import { ThemeType } from "@markit/common.types";
import "../../css/EmptyStates/EmptyUserState.css";
import { Colors } from "../../utils/colors";
import TopHeader from "../TopHeader";
import Footer from "../Footer";
import DownloadAppContainer from "../Containers/DownloadAppContainer";

type EmptyViewStateMobileProps = {
  eventTheme?: ThemeType;
};

const EmptyViewStateMobile = (props: EmptyViewStateMobileProps) => {
  const { eventTheme } = props;

  return (
    <div className="WebApp" style={{ transition: "0.5s" }}>
      <div style={{ paddingBottom: 12 }}>
        <TopHeader />
        <div
          className="ColumnNormal"
          style={{
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 14,
            height: 580,
            marginInline: 10,
            backgroundColor: Colors.WHITE,
          }}
        >
          <DownloadAppContainer
            subtext={
              "Manage and create products with Markit on desktop or in the Markit app"
            }
            eventTheme={eventTheme}
          />
        </div>
      </div>
      <Footer eventTheme={eventTheme} />
    </div>
  );
};

export default EmptyViewStateMobile;
